"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFileUtils = require("react-file-utils");
var _CustomTriggerProvider = require("../CustomTriggerProvider");
var _streamChatReact = require("stream-chat-react");
var _components = require("../MessageInputInner/TeamMessageInput/components");
var _sendArrow = _interopRequireDefault(require("../../../../images/send-arrow.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var KEY_CODES = {
  ESC: '27'
};
var TeamMessageEditForm = function TeamMessageEditForm(props) {
  var pinsOpen = props.pinsOpen;
  var _useChannelStateConte = (0, _streamChatReact.useChannelStateContext)(),
    acceptedFiles = _useChannelStateConte.acceptedFiles,
    multipleUploads = _useChannelStateConte.multipleUploads,
    thread = _useChannelStateConte.thread;
  var _useTranslationContex = (0, _streamChatReact.useTranslationContext)(),
    t = _useTranslationContex.t;
  var _useMessageInputConte = (0, _streamChatReact.useMessageInputContext)(),
    clearEditingState = _useMessageInputConte.clearEditingState,
    handleSubmit = _useMessageInputConte.handleSubmit,
    isUploadEnabled = _useMessageInputConte.isUploadEnabled,
    maxFilesLeft = _useMessageInputConte.maxFilesLeft,
    openEmojiPicker = _useMessageInputConte.openEmojiPicker,
    uploadNewFiles = _useMessageInputConte.uploadNewFiles;
  (0, _react.useEffect)(function () {
    var onKeyDown = function onKeyDown(event) {
      if (event.keyCode === KEY_CODES.ESC && clearEditingState) {
        clearEditingState();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return function () {
      return document.removeEventListener('keydown', onKeyDown);
    };
  }, [clearEditingState]);
  var cancelEdit = function cancelEdit() {
    if (clearEditingState) {
      clearEditingState();
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__wrapper edit-form ".concat((!!thread || pinsOpen) && 'thread-open')
  }, /*#__PURE__*/_react.default.createElement(_CustomTriggerProvider.CustomTriggerProvider, null, /*#__PURE__*/_react.default.createElement(_reactFileUtils.ImageDropzone, {
    accept: acceptedFiles,
    disabled: !isUploadEnabled || maxFilesLeft === 0,
    handleFiles: uploadNewFiles,
    maxNumberOfFiles: maxFilesLeft,
    multiple: multipleUploads
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__input"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__top"
  }, isUploadEnabled && /*#__PURE__*/_react.default.createElement(_streamChatReact.UploadsPreview, null), /*#__PURE__*/_react.default.createElement(_streamChatReact.EmojiPicker, {
    small: true
  }), /*#__PURE__*/_react.default.createElement(_streamChatReact.ChatAutoComplete, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__button-height-control"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__button",
    "aria-roledescription": "button",
    onClick: handleSubmit,
    style: {
      backgroundImage: "url(".concat(_sendArrow.default, ")")
    },
    role: "button"
  }, /*#__PURE__*/_react.default.createElement(_components.SendButton, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__bottom edit-form"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__icons"
  }, /*#__PURE__*/_react.default.createElement(_components.SmileyFace, {
    openEmojiPicker: openEmojiPicker
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-divider"
  }), /*#__PURE__*/_react.default.createElement(_reactFileUtils.FileUploadButton, {
    accepts: acceptedFiles,
    disabled: maxFilesLeft === 0,
    handleFiles: uploadNewFiles,
    multiple: multipleUploads
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__cancel",
    onClick: cancelEdit
  }, t('Cancel'))))))));
};
var _default = TeamMessageEditForm;
exports.default = _default;